import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { logout } from '../../store/authSlice';
import {
  FaPhone,
  FaEnvelope,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaBars,
  FaSearch,
  FaShoppingCart,
  FaAngleDown,
  FaAngleRight,
  FaUser, FaSignOutAlt
} from 'react-icons/fa';

import logo from '../../assets/images/logo.png';
import logo_white from '../../assets/images/logo-white.png';
const Header = () => {

const [open, setOpen] = useState(false);
const { user, isAuthenticated } = useSelector((state) => state.auth);
const dispatch = useDispatch();
const navigate = useNavigate();
const location = useLocation();
const isHome = location.pathname === '/';
const headerClassName = `main_header_area${isHome ? '' : ' colored_menu'}`;

const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };
  return (
    
    <header className={headerClassName}>

      {/* TOP BAR */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="contact-info">
              <p><FaPhone /> 123-456-79459</p>
              <p><FaEnvelope /> info@hospital.com</p>
            </div>
            <div className="header-links">
              <ul>
                <li><a href="#"><FaFacebookF /></a></li>
                <li><a href="#"><FaTwitter /></a></li>
                <li><a href="#"><FaInstagram /></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN MENU */}
      <div className="header_menu affix-top">
        <nav className="navbar navbar-default">
          <div className="container">

            {/* LOGO */}
            <div className="navbar-header">
              <Link className="navbar-brand" to="/">
                <img src={logo_white} alt="logo white" />
                <img src={logo} alt="logo" />
              </Link>

              
            </div>

            {/* MENU */}
            <div className={`navbar-nav-wrapper ${open ? 'open' : ''}`}>
              <ul className="nav navbar-nav" id="responsive-menu">

                {/* HOME */}
                <li><Link to="/">Home</Link></li>
                                
                <li className="dropdown submenu active">
                  <Link to="/about">About <FaAngleDown /></Link>
                  <ul className="dropdown-menu">
                    <li><Link to="/">Home Slider</Link></li>
                    <li><Link to="/index-dental">Home Dental</Link></li>

                  </ul>
                </li>
              <li><Link to="/doctors">Doctors</Link></li>
              <li><Link to="/departments">Departments</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              
                {isAuthenticated ? (
              <li>
                  <div className="user-menu">
                    <span className="user-name">
                    <FaUser /> {user?.name}
                    </span>
                    <button onClick={handleLogout} className="btn btn-outline">
                      <FaSignOutAlt /> Logout
                    </button>
                  </div>
                  <Link to="/login" >Login</Link>
              </li>
                ) : (

                 <li><Link to="/book-appointment"> Book Appointment</Link></li>
                )
                }
              </ul>
            </div>
          </div>
          <div id="slicknav-mobile"></div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
